import { Milliseconds, Networks } from '@iotv/iotv-v3-types';
import { v4 } from 'uuid';
import ApiGateway from '../../data/aws/api-gateway/ApiGateway';
const { REACT_APP_AWS_ACCOUNT_ID: accountID, REACT_APP_PROJECT_CODE: env, REACT_APP_DEPLOYMENT_STAGE: stage, } = process.env;
const path = `/emuData`;
const ttl = Date.now() + Milliseconds.DAY * 7;
export const calculatePayloads = async (baseEntity, reading, device, customer, property) => {
    const parsedEntity = baseEntity;
    let formatted = calculatePayload(parsedEntity, reading, device, customer, property);
    (await ApiGateway.post(path, { ...formatted }, 'NetworkApi'));
};
export const calculatePayload = (entity, reading, device, customer, property) => {
    const { timestamp, id, ...remaining } = reading; // do not need ID (timestamp) in the message
    let typedFormatted = entity;
    const formatted = {
        thing: typedFormatted,
        timestamp,
        thingShadowState: {
            timestamp,
            type: 'ThingShadowState',
            id: `${v4()}_${timestamp}`,
            name: entity.name ?? '',
            pk: `${typedFormatted.pk}`,
            sk: `${typedFormatted.sk}_latestShadowState`,
            ttl,
            payload: {
                state: {
                    reported: {
                        ...remaining,
                        meta: {
                            resolvedCustomer: customer,
                            resolvedProperty: property,
                            deviceId: `${device.id}`,
                            customerDeviceId: `${device.id}`,
                            deviceEui: `${device.id}`,
                            timestamp: timestamp,
                            accountId: accountID,
                            projectCode: env,
                            systemStage: stage,
                            fCnt: 1,
                            networkKey: Networks.AWS_LPWAN,
                            applicationId: undefined,
                            adr: undefined,
                            bw: undefined,
                            dr: undefined,
                            frequency: undefined,
                            gatewayEui: undefined,
                            rssi: undefined,
                            sf: undefined,
                            snr: undefined,
                        },
                    },
                    calculated: { ...remaining },
                },
                thingId: typedFormatted.id,
                thingSk: typedFormatted.pk,
            },
        },
        device,
    };
    return formatted;
};
